
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const ProgressChartSkeleton = ({ taskType }: { taskType: number }) => (
  <Card className="border border-stone-200 dark:border-stone-700 shadow-sm dark:bg-stone-800">
    <CardHeader className="px-8">
      <CardTitle className="text-xl dark:text-white">Progress Task {taskType}</CardTitle>
    </CardHeader>
    <CardContent className="px-8 pb-6">
      <div className="h-[300px] space-y-4">
        <Skeleton className="h-full w-full" />
      </div>
    </CardContent>
  </Card>
);
